import { useMemo, useState, useEffect } from 'react';
import { Modal, Card, Col, Row, Button, Nav, Tab } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import BankInfo from '../../components/BankInfo/BankInfo';
import ContactPerson from '../../components/ContactPerson/ContactPerson';
import Gst from '../../components/Gst/Gst';
import Address from '../../components/Address/Address';
import { FaLandmark, FaEdit, FaTrashAlt } from "react-icons/fa";
import Autocomplete from '../../components/Autocomplete/Autocomplete';
import { postOrgContactPersonSaveAccess, postOrgAssociatePartner, getOrgAssociatePartnerDetails, postOrgAssociatePartnerSave, postOrgAssociatePartnerSaveReferences, deleteOrgAssociatePartner, postCommonMaster, deleteAddressInfo, deleteGstInfo, deleteBanksInfo, deleteContactInfo, postOrganizationDetail, postOrganizationProfile } from '../../apiservices/ApiServices';
import DateFild from '../../components/DateTimePicker/DateFild';
import StarRating from '../../components/StarRating/StarRating';
import dayjs from 'dayjs';
import 'dayjs/locale/en';

const AssociatePartner = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [commonMaster, setCommonMaster] = useState([]);
    const [subSectorOptions, setSubSectorOptions] = useState([]);
    const [steps, setSteps] = useState(0);
    const [firstStp, setFirstStp] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [orgData, setOrgData] = useState([]);
    const [shows, setShows] = useState(false);
    const [fildsName, setFildsName] = useState('');
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteAddress, setDeleteAddress] = useState([]);
    const [deleteGst, setDeleteGst] = useState([]);
    const [deleteBank, setDeleteBank] = useState([]);
    const [deleteContact, setDeleteContact] = useState([]);
    const [addBank, setAddBank] = useState(false);
    const [addContactPerson, setAddContactPerson] = useState(false);
    const [addAddress, setAddAddress] = useState(false);
    const [addGst, setAddGst] = useState(false);
    const [addressList, setAddressList] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [contactPersonList, setContactPersonList] = useState([]);
    const [gstList, setGstList] = useState([]);
    const [editAddress, setEditAddress] = useState(null);
    const [editGst, setEditGst] = useState(null);
    const [editBank, setEditBank] = useState(null);
    const [editContact, setEditContact] = useState(null);
    const [addressModal, setAddressModal] = useState(false);
    const [gstModal, setGstModal] = useState(false);
    const [bankModal, setBankModal] = useState(false);
    const [contactModal, setContactModal] = useState(false);
    const [showLogModal, setShowLogModal] = useState(false);
    const [ids, setIds] = useState(null);

    const postOrgAssociatePartners = async (postData) => {
        setLoading(true);
        try {
            const res = await postOrgAssociatePartner(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.associate_partner_id,
                APCode: item?.associate_partner_code,
                orgName: item?.org_organization.org_name,
                orgNameId: item?.org_organization.org_id,
                orgGroupName: item?.org_group?.org_group_name || 'N/A',
                orgGroupNameid: item?.org_group?.org_group_id || 'N/A',
                contactPersion: `${item?.org_contact_person?.first_name} ${item?.org_contact_person?.last_name}`,
                email: item?.org_contact_person?.email || 'N/A',
                mobile: item?.org_contact_person?.mobile_number || 'N/A',
                stage: item?.stage,

                orgAddressId: item?.org_address?.address_id || '',
                orgGstId: item?.org_gst?.gst_id || '',
                orgBankId: item?.org_bank?.bank_account_id || '',
                orgContactId: item?.org_contact_person?.primary_contact_id || '',
            }));
            setData(formattedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateOrgAssociatePartner = async () => {
        let postData = {
            length: 100
        }
        try {
            const res = await postOrgAssociatePartner(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.associate_partner_id,
                APCode: item?.associate_partner_code,
                orgName: item?.org_organization.org_name,
                orgNameId: item?.org_organization.org_id,
                orgGroupName: item?.org_group?.org_group_name || 'N/A',
                orgGroupNameid: item?.org_group?.org_group_id || 'N/A',
                contactPersion: `${item?.org_contact_person?.first_name} ${item?.org_contact_person?.last_name}`,
                email: item?.org_contact_person?.email || 'N/A',
                mobile: item?.org_contact_person?.mobile_number || 'N/A',
                stage: item?.stage,

                orgAddressId: item?.org_address?.address_id || '',
                orgGstId: item?.org_gst?.gst_id || '',
                orgBankId: item?.org_bank?.bank_account_id || '',
                orgContactId: item?.org_contact_person?.primary_contact_id || '',
            }));
            setData(formattedData);
        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postOrgAssociatePartners(postData);
    }, []);

    const initialValues = {
        id: '',
        orgNameId: '',
        orgName: '',
        orgGroupId: '',
        orgGroupName: '',
        displayName: '',
        pan: '',
        cin: '',
        revenueBand: '',
        employeeBand: '',
        orgStructureIncomeTax: '',
        orgBroadStructure: '',
        sectorId: '',
        subSectorids: [],
        engagementDate: dayjs().format('DD-MM-YYYY'),
        incorporationDate: '',
        isActive: 1,
        isListed: 0,

        rating: '',
        stage: '',

        addressId: '',
        gstId: '',
        bankId: '',
        contactId: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            let postData = {
                associate_partner_id: values.id || '',
                org_id: values.orgNameId,
                organization: {
                    org_name: values.orgName,
                    org_group_id: values.orgGroupId,
                    org_group_name: values.orgGroupName,
                    org_group_description: "",
                    display_name: values.displayName,
                    pan: values.pan || '',
                    cin: values.cin,
                    revenue_band_id: values.revenueBand,
                    employee_band_id: values.employeeBand,
                    income_tax_structure_id: values.orgStructureIncomeTax,
                    org_broad_structure_id: values.orgBroadStructure,
                    sector_id: values.sectorId,
                    sub_sector_ids: values.subSectorids || [],
                    engagement_date: values.engagementDate,
                    incorporation_date: values.incorporationDate,
                    is_active: values.isActive,
                    is_listed: values.isListed,
                },
                qc_rating: values.rating,
                stage_id: values.stage
            }

            try {
                const res = await postOrgAssociatePartnerSave(postData);
                toast.success(res.data.message);
                setSteps(1);
                setFirstStp(true);
                setLoadings(false);

                setFieldValue('id', res?.data?.data?.associate_partner_id || '');
                setFieldValue('orgNameId', res?.data?.data?.org_id || '');
                setFieldValue('orgGroupId', res?.data?.data?.org_group_id || '');

                if (editModal) {
                    postUpdateOrgAssociatePartner();
                }

            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const postSaveReference = async () => {
        setLoadings(true);
        let postData = {
            associate_partner_id: values.id,
            ...(values.addressId && { address_id: values.addressId }),
            ...(values.gstId && { gst_id: values.gstId }),
            ...(values.bankId && { bank_account_id: values.bankId }),
            ...(values.contactId && { primary_contact_id: values.contactId })
        }
        try {
            const res = await postOrgAssociatePartnerSaveReferences(postData);
            toast.success(res.data.message);
            setAddModal(false);
            setEditModal(false);

            setAddressModal(false);
            setGstModal(false);
            setBankModal(false);
            setContactModal(false);

            setIds(null);


            postUpdateOrgAssociatePartner();
            setSteps(0);
            setFirstStp(false);
            setLoadings(false);

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postOrganizationDetails = async (id) => {
        setLoading(true);
        let postData = {
            id: id,
            check: 'AP'
        }
        try {
            const res = await postOrganizationDetail(postData);
            setOrgData(res.data.data);
            console.log(res.data.data)
            setLoading(false);
            setIsError(false);
            setErrorMsg('');

            setFieldValue('displayName', res?.data?.data?.display_name || '');
            setFieldValue('orgGroupId', res?.data?.data?.org_group?.org_group_id || '');
            setFieldValue('orgGroupName', res?.data?.data?.org_group?.org_group_name || '');
            setFieldValue('cin', res?.data?.data?.cin || '');
            setFieldValue('pan', res?.data?.data?.pan || '');
            setFieldValue('revenueBand', res?.data?.data?.revenue_band?.id || '');
            setFieldValue('employeeBand', res?.data?.data?.employee_band?.id || '');
            setFieldValue('orgStructureIncomeTax', res?.data?.data?.income_tax_structure?.id || '');
            setFieldValue('orgBroadStructure', res?.data?.data?.broad_structure?.id || '');
            setFieldValue('sectorId', res?.data?.data?.sector?.sector_id || '');
            setFieldValue('engagementDate', res?.data?.data?.engagement_date || '');
            setFieldValue('incorporationDate', res?.data?.data?.incorporation_date || '');

        } catch (error) {
            setIsError(true);
            setErrorMsg(error.response?.data?.message);
            setLoading(false);
            toast.error(error.response?.data?.message);

            setFieldValue('displayName', '');
            setFieldValue('orgGroupId', '');
            setFieldValue('orgGroupName', '');
            setFieldValue('cin', '');
            setFieldValue('pan', '');
            setFieldValue('revenueBand', '');
            setFieldValue('employeeBand', '');
            setFieldValue('orgStructureIncomeTax', '');
            setFieldValue('orgBroadStructure', '');
            setFieldValue('sectorId', '');
            setFieldValue('engagementDate', '');
            setFieldValue('incorporationDate', '');
        }
    };

    const addnew = async () => {
        setAddBank(false);
        setAddContactPerson(false);
        setAddAddress(false);
        setAddAddress(false);
        setEditAddress(null);
        setEditGst(null);
        setEditBank(null);
        setEditContact(null);

        formik.resetForm();
        setLoadings(true);
        let postData = {
            type: [
                "state",
                "revenue_band",
                "employee_band",
                "tax_structure",
                "broad_structure",
                "sector",
                "org_group",
                "organization",
                "function",
                "stages"
            ],
            org_type_code: 'AP'
        }
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);

            const revenueBandOption = res.data?.data?.revenue_band.find(item => item?.is_default === 1);
            if (revenueBandOption) { setFieldValue('revenueBand', revenueBandOption.id); }

            const employeeBandOption = res.data?.data?.employee_band.find(item => item?.is_default === 1);
            if (employeeBandOption) { setFieldValue('employeeBand', employeeBandOption.id); }

            const orgStructureIncomeTaxOption = res.data?.data?.tax_structure.find(item => item?.is_default === 1);
            if (orgStructureIncomeTaxOption) { setFieldValue('orgStructureIncomeTax', orgStructureIncomeTaxOption.id); }

            const orgBroadStructureOption = res.data?.data?.broad_structure.find(item => item?.is_default === 1);
            if (orgBroadStructureOption) { setFieldValue('orgBroadStructure', orgBroadStructureOption.id); }




            setLoadings(false);
            setAddModal(true);
            setSteps(0);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        if (values.sectorId) {
            const selectedSector = commonMaster?.sector.find(sector => sector.sector_id == values.sectorId);

            if (selectedSector && selectedSector.sub_sectors && selectedSector.sub_sectors.length > 0) {
                console.log(selectedSector.sub_sectors)
                setSubSectorOptions(selectedSector.sub_sectors);
            } else {
                setSubSectorOptions([]);
            }
        } else {
            setSubSectorOptions([]);
        }
    }, [values.sectorId]);

    useEffect(() => {
        if (!editModal) {
            if (values.orgNameId == '') {
                setFieldValue('displayName', '');
                setFieldValue('orgGroupId', '');
                setFieldValue('orgGroupName', '');
                setFieldValue('cin', '');
                setFieldValue('pan', '');
                setFieldValue('revenueBand', '');
                setFieldValue('employeeBand', '');
                setFieldValue('orgStructureIncomeTax', '');
                setFieldValue('orgBroadStructure', '');
                setFieldValue('sectorId', '');
                setFieldValue('engagementDate', '');
                setFieldValue('incorporationDate', '');
                setIsError(false);
                setErrorMsg('');
            }
            else {

                if (steps == 0) {
                    setIsError(false);
                    setErrorMsg('');
                    postOrganizationDetails(values.orgNameId);
                }
            }
        }
    }, [values.orgNameId])

    const postOrganizationProfiles = async (postData) => {
        setLoadings(true);
        try {
            const res = await postOrganizationProfile(postData);
            setAddressList(res.data.data.saved_address);
            setBankList(res.data.data.bank_accounts);
            setContactPersonList(res.data.data.contact_persons);
            setGstList(res.data.data.gst);
            console.log(res.data.data)
            setLoadings(false);
            toast.success(res?.data?.message);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message);
        }
    };

    useEffect(() => {
        if (steps == 1) {
            let postData = {
                id: values.orgNameId,
                org_type_code: 'AP'
            }
            postOrganizationProfiles(postData);
        }
    }, [steps]);

    const postUpdateOrganizationProfiles = async () => {
        setLoadings(true);
        let postData = {
            id: values.orgNameId || ids,
            org_type_code: 'AP'
        }
        try {
            const res = await postOrganizationProfile(postData);
            setAddressList(res.data.data.saved_address);
            setBankList(res.data.data.bank_accounts);
            setContactPersonList(res.data.data.contact_persons);
            setGstList(res.data.data.gst);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message);
        }
    };

    const postUpdateOrgProfiles = async () => {
        setLoadings(true);
        let postData = {
            id: ids,
            org_type_code: 'AP'
        }
        try {
            const res = await postOrganizationProfile(postData);
            setAddressList(res.data.data.saved_address);
            setBankList(res.data.data.bank_accounts);
            setContactPersonList(res.data.data.contact_persons);
            setGstList(res.data.data.gst);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message);
        }
    };

    const handleDeletes = async () => {
        setLoadings(true);
        if (fildsName == 'address') {
            try {
                const res = await deleteAddressInfo(deleteAddress?.address_id);
                toast.success(res.data.message);
                setLoadings(false);
                setShows(false);
                postUpdateOrganizationProfiles();
                setFildsName('');
                setDeleteAddress('');
            } catch (error) {
                setLoadings(false);
                setShows(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        }
        else if (fildsName == 'gst') {
            try {
                const res = await deleteGstInfo(deleteGst?.gst_id);
                toast.success(res.data.message);
                setLoadings(false);
                setShows(false);
                postUpdateOrganizationProfiles();
                setFildsName('');
                setDeleteGst('');
            } catch (error) {
                setLoadings(false);
                setShows(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        }
        else if (fildsName == 'bank') {
            try {
                const res = await deleteBanksInfo(deleteBank?.bank_account_id);
                toast.success(res.data.message);
                setLoadings(false);
                setShows(false);
                postUpdateOrganizationProfiles();
                setFildsName('');
                setDeleteBank('');
            } catch (error) {
                setLoadings(false);
                setShows(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        }
        else if (fildsName == 'contact') {
            try {
                const res = await deleteContactInfo(deleteContact?.contact_person_id);
                toast.success(res.data.message);
                setLoadings(false);
                setShows(false);
                postUpdateOrganizationProfiles();
                setFildsName('');
                setDeleteContact('');
            } catch (error) {
                setLoadings(false);
                setShows(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        }
        else {
            setLoadings(false);
            setShows(false);
            toast.error("Something wrong");
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: "AP Code",
                accessor: "APCode",
            },
            {
                Header: "Org. Name",
                accessor: "orgName",
            },
            {
                Header: "Org. Group Name",
                accessor: "orgGroupName",
            },
            {
                Header: "Contact persion",
                accessor: "contactPersion",
            },
            {
                Header: "Email",
                accessor: "email",
            },
            {
                Header: "Mobile",
                accessor: "mobile",
            },
            {
                Header: "Stage",
                accessor: "stage",
                Cell: ({ value }) => {
                    if (!value) return null;
                    return (
                        <span
                            className='stageBox'
                            style={{
                                backgroundColor: value.stage_color,
                            }}
                        >
                            {value.stage_name}
                        </span>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete', 'Address', 'gstInfo', 'bankInfo', 'contactInfo']
    const subActions = []

    const handleEdit = async (rowData) => {
        setAddBank(false);
        setAddContactPerson(false);
        setAddAddress(false);
        setAddAddress(false);
        setEditAddress(null);
        setEditGst(null);
        setEditBank(null);
        setEditContact(null);

        formik.resetForm();
        setLoadings(true);
        let postData = {
            type: [
                "state",
                "employee_band",
                "revenue_band",
                "tax_structure",
                "broad_structure",
                "sector",
                "org_group",
                "organization",
                "function",
                "stages"
            ],
            org_type_code: 'AP'
        }
        try {
            const commonData = await postCommonMaster(postData);
            setCommonMaster(commonData.data.data);
            try {
                const res = await getOrgAssociatePartnerDetails(rowData.id);

                setFieldValue('id', res.data.data?.associate_partner_id || '');
                setFieldValue('orgNameId', res.data.data?.org_organization?.org_id || '');
                setFieldValue('orgName', res.data.data?.org_organization?.org_name || '');
                setFieldValue('displayName', res.data.data?.org_organization?.display_name || '');
                setFieldValue('orgGroupId', res.data.data?.org_organization?.org_group?.org_group_id || '');
                setFieldValue('orgGroupName', res.data.data?.org_organization?.org_group?.org_group_name || '');
                setFieldValue('pan', res.data.data?.org_organization?.pan || '');
                setFieldValue('cin', res.data.data?.org_organization?.cin || '');
                setFieldValue('revenueBand', res.data.data?.org_organization?.revenue_band?.id || '');
                setFieldValue('employeeBand', res.data.data?.org_organization?.employee_band?.id || '');
                setFieldValue('orgStructureIncomeTax', res.data.data?.org_organization?.income_tax_structure?.id || '');
                setFieldValue('orgBroadStructure', res.data.data?.org_organization?.broad_structure?.id || '');
                setFieldValue('sectorId', res.data.data?.org_organization?.sector?.sector_id || '');
                setFieldValue('subSectorids', res.data.data?.org_organization?.sub_sector_ids || []);
                setFieldValue('engagementDate', res.data.data?.org_organization?.engagement_date || '');
                setFieldValue('incorporationDate', res.data.data?.org_organization?.incorporation_date || '');
                setFieldValue('isActive', res.data.data?.org_organization?.is_listed ? 1 : 0);
                setFieldValue('isListed', res.data.data?.org_organization?.is_active ? 1 : 0);

                setFieldValue('rating', res.data.data?.qc_rating || '');
                setFieldValue('stage', res.data.data?.stage?.stage_id || '');

                setFieldValue('addressId', res.data.data?.org_address?.address_id || '');
                setFieldValue('gstId', res.data.data?.org_gst?.gst_id || '');
                setFieldValue('bankId', res.data.data?.org_bank?.bank_account_id || '');
                setFieldValue('contactId', res.data.data?.org_contact_person?.primary_contact_id || '');

                setSteps(0);
                setEditModal(true);
                setLoadings(false);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }


        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }

    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.id);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteOrgAssociatePartner(values.id);
            console.log(res.data)
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdateOrgAssociatePartner();
            setFieldValue('id', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);

        setShowLogModal(false);

        setAddressModal(false);
        setGstModal(false);
        setBankModal(false);
        setContactModal(false);

        setAddBank(false);
        setAddContactPerson(false);
        setAddAddress(false);
        setAddAddress(false);
        setEditAddress(null);
        setEditGst(null);
        setEditBank(null);
        setEditContact(null);


        setIds(null);
        formik.resetForm();
    };

    const handleModalInfo = async (rowData, name) => {
        setAddBank(false);
        setAddContactPerson(false);
        setAddAddress(false);
        setAddAddress(false);
        setEditAddress(null);
        setEditGst(null);
        setEditBank(null);
        setEditContact(null);

        setIds(rowData?.orgNameId);
        setFieldValue('orgName', rowData?.orgName);
        setFieldValue('id', rowData?.id);
        setFieldValue('addressId', rowData?.orgAddressId);
        setFieldValue('gstId', rowData?.orgGstId);
        setFieldValue('bankId', rowData?.orgBankId);
        setFieldValue('contactId', rowData?.orgContactId);

        setLoadings(true);

        let postData = {
            id: rowData.orgNameId,
            org_type_code: 'AP'
        }
        try {
            const res = await postOrganizationProfile(postData);
            setAddressList(res.data.data.saved_address);
            setBankList(res.data.data.bank_accounts);
            setContactPersonList(res.data.data.contact_persons);
            setGstList(res.data.data.gst);
            setLoadings(false);
            if (name == 'address') {
                setAddressModal(true);
            }
            else if (name == 'gst') {
                setGstModal(true);
            }
            else if (name == 'bank') {
                setBankModal(true);
            }
            else {
                let postDatas = {
                    type: [
                        "state",
                        "employee_band",
                        "revenue_band",
                        "tax_structure",
                        "broad_structure",
                        "sector",
                        "org_group",
                        "organization",
                        "function",
                        "stages"
                    ],
                    org_type_code: 'AP'
                }
                try {
                    const res = await postCommonMaster(postDatas);
                    setCommonMaster(res.data.data);
                    setContactModal(true);
                } catch (error) {
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

        } catch (error) {
            setLoadings(false);
            setAddressModal(false);
            setGstModal(false);
            setBankModal(false);
            setContactModal(false);
            toast.error(error.response?.data?.message);
        }
    };

    const handleLog = (rowData) => {
        setShowLogModal(true);
    };

    const handleSwitchToggle = async (contactId) => {
        setLoadings(true);
        let postData = {
            contact_person_id: contactId,
            org_type_code: 'AP'
        }
        try {
            const res = await postOrgContactPersonSaveAccess(postData);
            toast.success(res?.data?.message);
            setLoadings(false);
            setContactPersonList(prev => prev.map(data =>
                data.contact_person_id === contactId
                    ? { ...data, is_user_profile: data.is_user_profile ? false : true }
                    : data
            ));

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message);
        }

    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Associate Partner" active="Associate Partner" items={['Home', 'Org Module']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Associate Partner</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <Button
                                                        variant="primary"
                                                        onClick={() => addnew()}
                                                    >
                                                        Add New
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                        onLog={handleLog}
                                        onAddressInfo={handleModalInfo}
                                        onGstInfo={handleModalInfo}
                                        onBankInfo={handleModalInfo}
                                        onContactInfo={handleModalInfo}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modal
                show={addModal}
                size={'xl'}
                centered={true}
                backdrop={true}
            >
                <div className="modal-header">
                    <div className="modal-title h4" style={{ color: "#000" }}>Add new</div>
                    {!firstStp && <button onClick={() => { setAddModal(false); setEditAddress(null); }} type="button" className="btn-close" aria-label="Close"></button>}
                </div>
                <Modal.Body>
                    <form id='step0' onSubmit={handleSubmit} autoComplete="off">
                        <div className='steps' style={{ display: steps == 0 ? 'block' : 'none' }}>
                            <div className='fieldsets cols_5'>
                                <div className='fieldsets-title'>General Information</div>
                                <Row>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <Autocomplete
                                                name="orgName"
                                                label="Org Name"
                                                suggestions={commonMaster?.organization || []}
                                                placeholder="Type to search organizations..."
                                                value={values.orgName}
                                                displayField="org_name"
                                                valueField="org_id"
                                                onChange={(fieldName, value) => {
                                                    if (typeof value === 'object') {
                                                        setFieldValue('orgNameId', value.org_id);
                                                        setFieldValue('orgName', value.org_name);
                                                    } else {
                                                        setFieldValue(fieldName, value);
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                error={errors.orgName}
                                                touched={touched.orgName}
                                            />
                                            {errors.orgName && touched.orgName && (
                                                <p className="errormsg">{errors.orgName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <Autocomplete
                                                name="orgGroupName"
                                                label="Org Group Name"
                                                suggestions={commonMaster?.org_group || []}
                                                placeholder="Type to search Org. Group..."
                                                value={values.orgGroupName}
                                                displayField="org_group_name"
                                                valueField="org_group_id"
                                                onChange={(fieldName, value) => {
                                                    if (typeof value === 'object') {
                                                        setFieldValue('orgGroupId', value.org_group_id);
                                                        setFieldValue('orgGroupName', value.org_group_name);
                                                    } else {
                                                        setFieldValue(fieldName, value);
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                error={errors.orgName}
                                                touched={touched.orgName}
                                            />
                                            {errors.orgName && touched.orgName && (
                                                <p className="errormsg">{errors.orgName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Display Name</label>
                                            <input
                                                type='text'
                                                id="displayName"
                                                name="displayName"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.displayName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.displayName && touched.displayName && (
                                                <p className="errormsg">{errors.displayName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org pan.</label>
                                            <input
                                                type='text'
                                                id="pan"
                                                name="pan"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.pan}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.pan && touched.pan && (
                                                <p className="errormsg">{errors.pan}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org CIN No.</label>
                                            <input
                                                type='text'
                                                id="cin"
                                                name="cin"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.cin}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.cin && touched.cin && (
                                                <p className="errormsg">{errors.cin}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Revenue Band</label>
                                            <SelectFild
                                                Firstop='Select Org Revenue Band'
                                                selectName="revenueBand"
                                                options={commonMaster?.revenue_band}
                                                value={values.revenueBand}
                                                onChange={(selectedOption) => setFieldValue("revenueBand", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.revenueBand && touched.revenueBand && (
                                                <p className="errormsg">{errors.revenueBand}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Employee Band</label>
                                            <SelectFild
                                                Firstop='Select Org Employee Band'
                                                selectName="employeeBand"
                                                options={commonMaster?.employee_band}
                                                value={values.employeeBand}
                                                onChange={(selectedOption) => setFieldValue("employeeBand", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.employeeBand && touched.employeeBand && (
                                                <p className="errormsg">{errors.employeeBand}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Structure Income Tax</label>
                                            <SelectFild
                                                Firstop='Select Org Structure Income Tax'
                                                selectName="orgStructureIncomeTax"
                                                options={commonMaster?.tax_structure}
                                                value={values.orgStructureIncomeTax}
                                                onChange={(selectedOption) => setFieldValue("orgStructureIncomeTax", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.orgStructureIncomeTax && touched.orgStructureIncomeTax && (
                                                <p className="errormsg">{errors.orgStructureIncomeTax}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Broad Structure</label>
                                            <SelectFild
                                                Firstop='Select Org Broad Structure'
                                                selectName="orgBroadStructure"
                                                options={commonMaster?.broad_structure}
                                                value={values.orgBroadStructure}
                                                onChange={(selectedOption) => setFieldValue("orgBroadStructure", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.orgBroadStructure && touched.orgBroadStructure && (
                                                <p className="errormsg">{errors.orgBroadStructure}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Sector</label>
                                            <SelectFild
                                                Firstop='Select Sector'
                                                selectName="sectorId"
                                                options={commonMaster?.sector}
                                                value={values.sectorId}
                                                onChange={(selectedOption) => setFieldValue("sectorId", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.sectorId && touched.sectorId && (
                                                <p className="errormsg">{errors.sectorId}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Sub Sector</label>
                                            <SelectFild
                                                Firstop='Select Sub Sector'
                                                selectName="subSectorids"
                                                options={subSectorOptions}
                                                value={values.subSectorids}
                                                onChange={(selectedOptions) => {
                                                    const selectedValues = selectedOptions ?
                                                        Array.isArray(selectedOptions) ?
                                                            selectedOptions.map(option => option.value) :
                                                            selectedOptions.value :
                                                        [];
                                                    setFieldValue('subSectorids', selectedValues);
                                                }}
                                                onBlur={handleBlur}
                                                isMulti={true}
                                            />
                                            {errors.subSectorids && touched.subSectorids && (
                                                <p className="errormsg">{errors.subSectorids}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Engagement Date</label>
                                            <DateFild
                                                value={values.engagementDate}
                                                onChange={(date) => setFieldValue('engagementDate', date)}
                                            />
                                            {errors.engagementDate && touched.engagementDate && (
                                                <p className="errormsg">{errors.engagementDate}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Incorporation Date</label>
                                            <DateFild
                                                value={values.incorporationDate}
                                                onChange={(date) => setFieldValue('incorporationDate', date)}
                                            />
                                            {errors.incorporationDate && touched.incorporationDate && (
                                                <p className="errormsg">{errors.incorporationDate}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className='d-flex align-items-center'>
                                            <div className="form-group w-50">
                                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                    <label className="form-label">Is Active</label>
                                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                                        <input
                                                            type="checkbox"
                                                            id='isActive'
                                                            name='isActive'
                                                            className="form-control"
                                                            autoComplete='off'
                                                            checked={values.isActive === 1}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    'isActive',
                                                                    e.target.checked ? 1 : 0
                                                                );
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span className="slider round"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group w-50">
                                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                    <label className="form-label">Is Listed</label>
                                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                                        <input
                                                            type="checkbox"
                                                            id='isListed'
                                                            name='isListed'
                                                            className="form-control"
                                                            autoComplete='off'
                                                            checked={values.isListed === 1}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    'isListed',
                                                                    e.target.checked ? 1 : 0
                                                                );
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span className="slider round"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className='fieldsets cols_5'>
                                <div className='fieldsets-title'>Associate Partner Information</div>
                                <Row>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Qc Rating</label>
                                            <StarRating
                                                name="rating"
                                                value={values.rating}
                                                setFieldValue={setFieldValue}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Stage</label>
                                            <div className='stagesbox'>
                                                <ul>
                                                    {commonMaster?.stages?.map((item) => (
                                                        <li key={`Stage_${item?.stage_id}`}>
                                                            <div className='stage' style={{ backgroundColor: item?.stage_color }}>
                                                                <input
                                                                    type="radio"
                                                                    name="stage"
                                                                    value={item?.stage_id}
                                                                    checked={values.stage == item?.stage_id}
                                                                    onChange={(e) => {
                                                                        setFieldValue(
                                                                            'stage',
                                                                            e.target.checked ? item?.stage_id : ''
                                                                        );
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <div className='chkmarksbox'></div>
                                                                <p>{item?.stage_name}</p>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            {/* <SelectFild
                                                Firstop='Select Stage'
                                                selectName="stage"
                                                options={commonMaster?.stages}
                                                value={values.stage}
                                                onChange={(selectedOption) => setFieldValue("stage", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            /> */}
                                            {errors.stage && touched.stage && (
                                                <p className="errormsg">{errors.stage}</p>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            {isError && <div className='mainerror'><p className="errormsg">{errorMsg}</p></div>}
                            <div className='modalfooters'>
                                <div className='button-boxs grid'>
                                    {firstStp ?
                                        <>
                                            <button type='submit' className='btn btn-primary'>update & Next</button>
                                            <button type='button' onClick={() => setSteps(1)} className='btn btn-btn btn-default'>Next</button>
                                        </>
                                        :
                                        <>
                                            <button type='submit' className='btn btn-primary'>Save Next</button>
                                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                                        </>

                                    }
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className='steps' style={{ display: steps == 1 ? 'block' : 'none' }}>
                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Address</h6>
                                <div onClick={() => setAddAddress(!addAddress)} className='btnlinks'>+ Add New</div>
                            </div>

                            <div className='banksbox'>
                                {addAddress &&
                                    <Address
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddAddress={setAddAddress}
                                        setEditAddress={setEditAddress}
                                        editAddress={editAddress}
                                    />
                                }
                                <div className='addressCardsbox'>
                                    <Row>
                                        {addressList.map((item) => (
                                            <Col md={4} key={`address${item?.address_id}`}>
                                                <div className='addressCard'>
                                                    <div className='addresshed'>
                                                        <input
                                                            type="radio"
                                                            name="address"
                                                            value={item?.address_id}
                                                            checked={item?.address_id == values.addressId}
                                                            onChange={() =>
                                                                setFieldValue('addressId', item?.address_id)
                                                            }
                                                        />
                                                        <div className='btns'>
                                                            <button onClick={() => { setAddAddress(true); setEditAddress(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button onClick={() => { setShows(true); setFildsName('address'); setDeleteAddress(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className='addrestype'>
                                                        <FaLandmark /><span>{item?.address_type}</span>
                                                    </div>
                                                    <p>{item?.address_line1} {item?.area}, {item?.city}, {item?.pincodes?.state_name},{item?.pincodes?.pincode}, {item?.pincodes?.country_name}</p>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </div>
                        </div>
                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>GST</h6>
                                <div onClick={() => setAddGst(!addGst)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='banksbox'>
                                {addGst &&
                                    <Gst
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddGst={setAddGst}
                                        setEditGst={setEditGst}
                                        editGst={editGst}
                                        addressList={addressList}
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>Gst In</th>
                                                <th>Legal Name</th>
                                                <th>Trade Name</th>
                                                <th>Pan</th>
                                                <th>Registration Date</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {gstList.map((item) => (
                                                <tr
                                                    key={`gst${item?.gst_id}`}
                                                    className={item?.gst_id === values.gstId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="gst"
                                                            value={item?.gst_id}
                                                            checked={item?.gst_id == values.gstId}
                                                            onChange={() =>
                                                                setFieldValue('gstId', item?.gst_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.gstin}</td>
                                                    <td>{item?.legal_name}</td>
                                                    <td>{item?.trade_name}</td>
                                                    <td>{item?.pan}</td>
                                                    <td style={{ textAlign: 'left !important' }}>{item?.registration_date}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddGst(true); setEditGst(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('gst'); setDeleteGst(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Banks Information</h6>
                                <div onClick={() => setAddBank(!addBank)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='fieldsets-title'>Banks Information</div>
                            <div className='banksbox'>
                                {addBank &&
                                    <BankInfo
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddBank={setAddBank}
                                        setEditBank={setEditBank}
                                        editBank={editBank}
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>Bank Name</th>
                                                <th>Branch Name</th>
                                                <th>Account Number</th>
                                                <th>Beneficiary Name</th>
                                                <th>IFSC Code</th>
                                                <th>MICR Code</th>
                                                <th>Swift Code</th>
                                                <th>Account Type Code</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bankList.map((item) => (
                                                <tr
                                                    key={`banks${item?.bank_account_id}`}
                                                    className={item?.bank_account_id === values?.bankId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="banks"
                                                            value={item?.bank_account_id}
                                                            checked={item?.bank_account_id == values?.bankId}
                                                            onChange={() =>
                                                                setFieldValue('bankId', item?.bank_account_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.bank_name}</td>
                                                    <td>{item?.bank_branch_name}</td>
                                                    <td>{item?.account_number}</td>
                                                    <td>{item?.beneficiary_name}</td>
                                                    <td>{item?.bank_ifsc_code}</td>
                                                    <td>{item?.bank_micr_code}</td>
                                                    <td>{item?.bank_swift_code}</td>
                                                    <td>{item?.account_type_code}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddBank(true); setEditBank(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('bank'); setDeleteBank(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Contact Person</h6>
                                <div onClick={() => setAddContactPerson(!addContactPerson)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='banksbox'>
                                {addContactPerson &&
                                    <ContactPerson
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddContactPerson={setAddContactPerson}
                                        setEditContact={setEditContact}
                                        editContact={editContact}
                                        functionList={commonMaster?.function}
                                        orgTypeCode='AP'
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Email Id</th>
                                                <th>Mobile Number</th>
                                                <th>Function</th>
                                                <th>Designation</th>
                                                <th>has User Profile</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contactPersonList?.map((item) => (
                                                <tr
                                                    key={`contactPerson${item?.contact_person_id}`}
                                                    className={item?.contact_person_id === values?.contactId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="contactPerson"
                                                            value={item?.contact_person_id}
                                                            checked={item?.contact_person_id == values?.contactId}
                                                            onChange={() =>
                                                                setFieldValue('contactId', item?.contact_person_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                    <td>{item?.function?.name}</td>
                                                    <td>{item?.designation?.name}</td>
                                                    <td>
                                                        <div className="switchs">
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.is_user_profile ? true : false}
                                                                onChange={() =>
                                                                    handleSwitchToggle(item?.contact_person_id)
                                                                }
                                                            />
                                                            <span className="slider round"></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddContactPerson(true); setEditContact(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('contact'); setDeleteContact(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className='modalfooters'>
                            <div className='button-boxs grid'>
                                <button type='button' onClick={() => setSteps(0)} className='btn btn-default'>Prev</button>
                                <button type='button' onClick={() => postSaveReference()} className='btn btn-primary'>Submit</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={editModal}
                size={'xl'}
                centered={true}
                backdrop={true}
            >
                <div className="modal-header">
                    <div className="modal-title h4" style={{ color: "#000" }}>Edit Client</div>
                    <button onClick={() => { setEditModal(false); setEditAddress(null); }} type="button" className="btn-close" aria-label="Close"></button>
                </div>
                <Modal.Body>
                    <form id='step0' onSubmit={handleSubmit} autoComplete="off">
                        <div className='steps' style={{ display: steps == 0 ? 'block' : 'none' }}>
                            <div className='fieldsets cols_5'>
                                <div className='fieldsets-title'>General Information</div>
                                <Row>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <Autocomplete
                                                name="orgName"
                                                label="Org Name"
                                                suggestions={commonMaster?.organization || []}
                                                placeholder="Type to search organizations..."
                                                value={values.orgName}
                                                displayField="org_name"
                                                valueField="org_id"
                                                onChange={(fieldName, value) => {
                                                    if (typeof value === 'object') {
                                                        setFieldValue('orgNameId', value.org_id);
                                                        setFieldValue('orgName', value.org_name);
                                                    } else {
                                                        setFieldValue('orgNameId', '');
                                                        setFieldValue('orgName', '');
                                                        setFieldValue(fieldName, value);
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                error={errors.orgName}
                                                touched={touched.orgName}
                                            />
                                            {errors.orgName && touched.orgName && (
                                                <p className="errormsg">{errors.orgName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <Autocomplete
                                                name="orgGroupName"
                                                label="Org Group Name"
                                                suggestions={commonMaster?.org_group || []}
                                                placeholder="Type to search Org. Group..."
                                                value={values.orgGroupName}
                                                displayField="org_group_name"
                                                valueField="org_group_id"
                                                onChange={(fieldName, value) => {
                                                    if (typeof value === 'object') {
                                                        setFieldValue('orgGroupId', value.org_group_id);
                                                        setFieldValue('orgGroupName', value.org_group_name);
                                                    } else {
                                                        setFieldValue(fieldName, value);
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                error={errors.orgName}
                                                touched={touched.orgName}
                                            />
                                            {errors.orgName && touched.orgName && (
                                                <p className="errormsg">{errors.orgName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    {/* <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Select Org Group</label>
                                            <SelectFild
                                                Firstop='Select Organization Group'
                                                selectName="orgGroupId"
                                                options={commonMaster?.org_group}
                                                value={values.orgGroupId}
                                                onChange={(selectedOption) => setFieldValue("orgGroupId", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.orgGroupId && touched.orgGroupId && (
                                                <p className="errormsg">{errors.orgGroupId}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Group Name</label>
                                            <input
                                                type='text'
                                                id="orgGroupName"
                                                name="orgGroupName"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.orgGroupName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.orgGroupName && touched.orgGroupName && (
                                                <p className="errormsg">{errors.orgGroupName}</p>
                                            )}
                                        </div>
                                    </Col> */}
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Display Name</label>
                                            <input
                                                type='text'
                                                id="displayName"
                                                name="displayName"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.displayName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.displayName && touched.displayName && (
                                                <p className="errormsg">{errors.displayName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org pan.</label>
                                            <input
                                                type='text'
                                                id="pan"
                                                name="pan"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.pan}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.pan && touched.pan && (
                                                <p className="errormsg">{errors.pan}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org CIN No.</label>
                                            <input
                                                type='text'
                                                id="cin"
                                                name="cin"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.cin}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.cin && touched.cin && (
                                                <p className="errormsg">{errors.cin}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Revenue Band</label>
                                            <SelectFild
                                                Firstop='Select Org Revenue Band'
                                                selectName="revenueBand"
                                                options={commonMaster?.revenue_band}
                                                value={values.revenueBand}
                                                onChange={(selectedOption) => setFieldValue("revenueBand", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.revenueBand && touched.revenueBand && (
                                                <p className="errormsg">{errors.revenueBand}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Employee Band</label>
                                            <SelectFild
                                                Firstop='Select Org Employee Band'
                                                selectName="employeeBand"
                                                options={commonMaster?.employee_band}
                                                value={values.employeeBand}
                                                onChange={(selectedOption) => setFieldValue("employeeBand", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.employeeBand && touched.employeeBand && (
                                                <p className="errormsg">{errors.employeeBand}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Structure Income Tax</label>
                                            <SelectFild
                                                Firstop='Select Org Structure Income Tax'
                                                selectName="orgStructureIncomeTax"
                                                options={commonMaster?.tax_structure}
                                                value={values.orgStructureIncomeTax}
                                                onChange={(selectedOption) => setFieldValue("orgStructureIncomeTax", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.orgStructureIncomeTax && touched.orgStructureIncomeTax && (
                                                <p className="errormsg">{errors.orgStructureIncomeTax}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Broad Structure</label>
                                            <SelectFild
                                                Firstop='Select Org Broad Structure'
                                                selectName="orgBroadStructure"
                                                options={commonMaster?.broad_structure}
                                                value={values.orgBroadStructure}
                                                onChange={(selectedOption) => setFieldValue("orgBroadStructure", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.orgBroadStructure && touched.orgBroadStructure && (
                                                <p className="errormsg">{errors.orgBroadStructure}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Sector</label>
                                            <SelectFild
                                                Firstop='Select Sector'
                                                selectName="sectorId"
                                                options={commonMaster?.sector}
                                                value={values.sectorId}
                                                onChange={(selectedOption) => setFieldValue("sectorId", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.sectorId && touched.sectorId && (
                                                <p className="errormsg">{errors.sectorId}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Sub Sector</label>
                                            <SelectFild
                                                Firstop='Select Sub Sector'
                                                selectName="subSectorids"
                                                options={subSectorOptions}
                                                value={values.subSectorids}
                                                onChange={(selectedOptions) => {
                                                    const selectedValues = selectedOptions ?
                                                        Array.isArray(selectedOptions) ?
                                                            selectedOptions.map(option => option.value) :
                                                            selectedOptions.value :
                                                        [];
                                                    setFieldValue('subSectorids', selectedValues);
                                                }}
                                                onBlur={handleBlur}
                                                isMulti={true}
                                            />
                                            {errors.subSectorids && touched.subSectorids && (
                                                <p className="errormsg">{errors.subSectorids}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Engagement Date</label>
                                            <DateFild
                                                value={values.engagementDate}
                                                onChange={(date) => setFieldValue('engagementDate', date)}
                                            />
                                            {errors.engagementDate && touched.engagementDate && (
                                                <p className="errormsg">{errors.engagementDate}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Incorporation Date</label>
                                            <DateFild
                                                value={values.incorporationDate}
                                                onChange={(date) => setFieldValue('incorporationDate', date)}
                                            />
                                            {errors.incorporationDate && touched.incorporationDate && (
                                                <p className="errormsg">{errors.incorporationDate}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className='d-flex align-items-center'>
                                            <div className="form-group w-50">
                                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                    <label className="form-label">Is Active</label>
                                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                                        <input
                                                            type="checkbox"
                                                            id='isActive'
                                                            name='isActive'
                                                            className="form-control"
                                                            autoComplete='off'
                                                            checked={values.isActive === 1}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    'isActive',
                                                                    e.target.checked ? 1 : 0
                                                                );
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span className="slider round"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group w-50">
                                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                    <label className="form-label">Is Listed</label>
                                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                                        <input
                                                            type="checkbox"
                                                            id='isListed'
                                                            name='isListed'
                                                            className="form-control"
                                                            autoComplete='off'
                                                            checked={values.isListed === 1}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    'isListed',
                                                                    e.target.checked ? 1 : 0
                                                                );
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span className="slider round"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className='fieldsets cols_5'>
                                <div className='fieldsets-title'>Associate Partner Information</div>
                                <Row>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Qc Rating</label>
                                            <StarRating
                                                name="rating"
                                                value={values.rating}
                                                setFieldValue={setFieldValue}
                                            />
                                        </div>
                                    </Col>

                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Stage</label>
                                            <div className='stagesbox'>
                                                <ul>
                                                    {commonMaster?.stages?.map((item) => (
                                                        <li key={`Stage_${item?.stage_id}`}>
                                                            <div className='stage' style={{ backgroundColor: item?.stage_color }}>
                                                                <input
                                                                    type="radio"
                                                                    name="stage"
                                                                    value={item?.stage_id}
                                                                    checked={values.stage == item?.stage_id}
                                                                    onChange={(e) => {
                                                                        setFieldValue(
                                                                            'stage',
                                                                            e.target.checked ? item?.stage_id : ''
                                                                        );
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <div className='chkmarksbox'></div>
                                                                <p>{item?.stage_name}</p>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            {/* <SelectFild
                                                Firstop='Select Stage'
                                                selectName="stage"
                                                options={commonMaster?.stages}
                                                value={values.stage}
                                                onChange={(selectedOption) => setFieldValue("stage", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            /> */}
                                            {errors.stage && touched.stage && (
                                                <p className="errormsg">{errors.stage}</p>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className='modalfooters'>
                                <div className='button-boxs grid'>
                                    <button type='submit' className='btn btn-primary'>update & Next</button>
                                    <button type='button' onClick={() => setSteps(1)} className='btn btn-btn btn-default'>Next</button>
                                    <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className='steps' style={{ display: steps == 1 ? 'block' : 'none' }}>
                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Address</h6>
                                <div onClick={() => setAddAddress(!addAddress)} className='btnlinks'>+ Add New</div>
                            </div>

                            <div className='banksbox'>
                                {addAddress &&
                                    <Address
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddAddress={setAddAddress}
                                        setEditAddress={setEditAddress}
                                        editAddress={editAddress}
                                    />
                                }
                                <div className='addressCardsbox'>
                                    <Row>
                                        {addressList.map((item, index) => (
                                            <Col md={4} key={`address${item?.address_id}`}>
                                                <div className='addressCard'>
                                                    <div className='addresshed'>
                                                        <input
                                                            type="radio"
                                                            name="address"
                                                            value={item?.address_id}
                                                            checked={item?.address_id == values.addressId}
                                                            onChange={() =>
                                                                setFieldValue('addressId', item?.address_id)
                                                            }
                                                        />
                                                        <div className='btns'>
                                                            <button onClick={() => { setAddAddress(true); setEditAddress(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button onClick={() => { setShows(true); setFildsName('address'); setDeleteAddress(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className='addrestype'>
                                                        <FaLandmark /><span>{item?.address_type}</span>
                                                    </div>
                                                    <p>{item?.address_line1} {item?.area}, {item?.city}, {item?.pincodes?.state_name},{item?.pincodes?.pincode}, {item?.pincodes?.country_name}</p>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </div>
                        </div>

                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>GST</h6>
                                <div onClick={() => setAddGst(!addGst)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='banksbox'>
                                {addGst &&
                                    <Gst
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddGst={setAddGst}
                                        setEditGst={setEditGst}
                                        editGst={editGst}
                                        addressList={addressList}
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>Gst In</th>
                                                <th>Legal Name</th>
                                                <th>Trade Name</th>
                                                <th>Pan</th>
                                                <th>Registration Date</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {gstList.map((item) => (
                                                <tr
                                                    key={`gst${item?.gst_id}`}
                                                    className={item?.gst_id === values.gstId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="gst"
                                                            value={item?.gst_id}
                                                            checked={item?.gst_id == values.gstId}
                                                            onChange={() =>
                                                                setFieldValue('gstId', item?.gst_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.gstin}</td>
                                                    <td>{item?.legal_name}</td>
                                                    <td>{item?.trade_name}</td>
                                                    <td>{item?.pan}</td>
                                                    <td style={{ textAlign: 'left !important' }}>{item?.registration_date}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddGst(true); setEditGst(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('gst'); setDeleteGst(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Banks Information</h6>
                                <div onClick={() => setAddBank(!addBank)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='fieldsets-title'>Banks Information</div>
                            <div className='banksbox'>
                                {addBank &&
                                    <BankInfo
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddBank={setAddBank}
                                        setEditBank={setEditBank}
                                        editBank={editBank}
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>Bank Name</th>
                                                <th>Branch Name</th>
                                                <th>Account Number</th>
                                                <th>Beneficiary Name</th>
                                                <th>IFSC Code</th>
                                                <th>MICR Code</th>
                                                <th>Swift Code</th>
                                                <th>Account Type Code</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bankList.map((item) => (
                                                <tr
                                                    key={`banks${item?.bank_account_id}`}
                                                    className={item?.bank_account_id === values.bankId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="banks"
                                                            value={item?.bank_account_id}
                                                            checked={item?.bank_account_id == values.bankId}
                                                            onChange={() =>
                                                                setFieldValue('bankId', item?.bank_account_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.bank_name}</td>
                                                    <td>{item?.bank_branch_name}</td>
                                                    <td>{item?.account_number}</td>
                                                    <td>{item?.beneficiary_name}</td>
                                                    <td>{item?.bank_ifsc_code}</td>
                                                    <td>{item?.bank_micr_code}</td>
                                                    <td>{item?.bank_swift_code}</td>
                                                    <td>{item?.account_type_code}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddBank(true); setEditBank(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('bank'); setDeleteBank(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Contact Person</h6>
                                <div onClick={() => setAddContactPerson(!addContactPerson)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='banksbox'>
                                {addContactPerson &&
                                    <ContactPerson
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddContactPerson={setAddContactPerson}
                                        setEditContact={setEditContact}
                                        editContact={editContact}
                                        functionList={commonMaster?.function}
                                        orgTypeCode='AP'
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Email Id</th>
                                                <th>Mobile Number</th>
                                                <th>Function</th>
                                                <th>Designation</th>
                                                <th>has User Profile</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contactPersonList?.map((item) => (
                                                <tr
                                                    key={`contactPerson${item?.contact_person_id}`}
                                                    className={item?.contact_person_id === values.contactId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="contactPerson"
                                                            value={item?.contact_person_id}
                                                            checked={item?.contact_person_id == values.contactId}
                                                            onChange={() =>
                                                                setFieldValue('contactId', item?.contact_person_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                    <td>{item?.function?.name}</td>
                                                    <td>{item?.designation?.name}</td>
                                                    <td>
                                                        <div className="switchs">
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.is_user_profile ? true : false}
                                                                onChange={() =>
                                                                    handleSwitchToggle(item?.contact_person_id)
                                                                }
                                                            />
                                                            <span className="slider round"></span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddContactPerson(true); setEditContact(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('contact'); setDeleteContact(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className='modalfooters'>
                            <div className='button-boxs grid'>
                                <button type='button' onClick={() => setSteps(0)} className='btn btn-default'>Prev</button>
                                <button type='button' onClick={() => postSaveReference()} className='btn btn-primary'>Submit</button>
                                <button type='button' onClick={handleConfirm} className='btn btn-default'>Closed</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modals
                show={addressModal}
                handleClose={() => setAddressModal(false)}
                title={`${values.orgName} Address Info`}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <div className='fieldsets'>
                    <div className='fieldsetsboxs'>
                        <h6>Address</h6>
                        <div onClick={() => setAddAddress(!addAddress)} className='btnlinks'>+ Add New</div>
                    </div>
                    <div className='banksbox'>
                        {addAddress &&
                            <Address
                                orgId={ids}
                                toast={toast}
                                postUpdateOrganizationProfiles={postUpdateOrgProfiles}
                                setAddAddress={setAddAddress}
                                setEditAddress={setEditAddress}
                                editAddress={editAddress}
                            />
                        }
                        <div className='addressCardsbox'>
                            <Row>
                                {addressList.map((item) => (
                                    <Col md={4} key={`address${item?.address_id}`}>
                                        <div className='addressCard'>
                                            <div className='addresshed'>
                                                <input
                                                    type="radio"
                                                    name="address"
                                                    value={item?.address_id}
                                                    checked={item?.address_id == values.addressId}
                                                    onChange={() =>
                                                        setFieldValue('addressId', item?.address_id)
                                                    }
                                                />
                                                <div className='btns'>
                                                    <button onClick={() => { setAddAddress(true); setEditAddress(item); }}>
                                                        <FaEdit />
                                                    </button>
                                                    <button onClick={() => { setShows(true); setFildsName('address'); setDeleteAddress(item); }}>
                                                        <FaTrashAlt />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='addrestype'>
                                                <FaLandmark /><span>{item?.address_type}</span>
                                            </div>
                                            <p>{item?.address_line1} {item?.area}, {item?.city}, {item?.pincodes?.state_name},{item?.pincodes?.pincode}, {item?.pincodes?.country_name}</p>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </div>
                </div>
                <div className='modalfooters'>
                    <div className='button-boxs grid'>
                        <button type='button' onClick={() => postSaveReference()} className='btn btn-primary'>Update</button>
                        <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                    </div>
                </div>
            </Modals>

            <Modals
                show={gstModal}
                handleClose={() => setGstModal(false)}
                title={`${values.orgName} Gst Info`}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >

                <div className='fieldsets'>
                    <div className='fieldsetsboxs'>
                        <h6>GST</h6>
                        <div onClick={() => setAddGst(!addGst)} className='btnlinks'>+ Add New</div>
                    </div>
                    <div className='banksbox'>
                        {addGst &&
                            <Gst
                                orgId={ids}
                                toast={toast}
                                postUpdateOrganizationProfiles={postUpdateOrgProfiles}
                                setAddGst={setAddGst}
                                setEditGst={setEditGst}
                                editGst={editGst}
                                addressList={addressList}
                            />
                        }
                        <div className="table-responsive">
                            <table className="table table-bordered text-nowrap mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ width: 60 }}></th>
                                        <th>Gst In</th>
                                        <th>Legal Name</th>
                                        <th>Trade Name</th>
                                        <th>Pan</th>
                                        <th>Registration Date</th>
                                        <th className='txt-center' style={{ width: 80 }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gstList.map((item) => (
                                        <tr
                                            key={`gst${item?.gst_id}`}
                                            className={item?.gst_id === values.gstId ? 'active' : ''}
                                        >
                                            <td className='rdotd'>
                                                <input
                                                    type="radio"
                                                    name="gst"
                                                    value={item?.gst_id}
                                                    checked={item?.gst_id == values.gstId}
                                                    onChange={() =>
                                                        setFieldValue('gstId', item?.gst_id)
                                                    }
                                                />
                                            </td>
                                            <td>{item?.gstin}</td>
                                            <td>{item?.legal_name}</td>
                                            <td>{item?.trade_name}</td>
                                            <td>{item?.pan}</td>
                                            <td style={{ textAlign: 'left !important' }}>{item?.registration_date}</td>
                                            <td>
                                                <div className="d-flex justify-content-center gap-2">
                                                    <button className='btn-action edit' onClick={() => { setAddGst(true); setEditGst(item); }}>
                                                        <FaEdit />
                                                    </button>
                                                    <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('gst'); setDeleteGst(item); }}>
                                                        <FaTrashAlt />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='modalfooters'>
                    <div className='button-boxs grid'>
                        <button type='button' onClick={() => postSaveReference()} className='btn btn-primary'>Update</button>
                        <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                    </div>
                </div>
            </Modals>

            <Modals
                show={bankModal}
                handleClose={() => setBankModal(false)}
                title={`${values.orgName} Bank Info`}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <div className='fieldsets'>
                    <div className='fieldsetsboxs'>
                        <h6>Banks Information</h6>
                        <div onClick={() => setAddBank(!addBank)} className='btnlinks'>+ Add New</div>
                    </div>
                    <div className='fieldsets-title'>Banks Information</div>
                    <div className='banksbox'>
                        {addBank &&
                            <BankInfo
                                orgId={ids}
                                toast={toast}
                                postUpdateOrganizationProfiles={postUpdateOrgProfiles}
                                setAddBank={setAddBank}
                                setEditBank={setEditBank}
                                editBank={editBank}
                            />
                        }
                        <div className="table-responsive">
                            <table className="table table-bordered text-nowrap mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ width: 60 }}></th>
                                        <th>Bank Name</th>
                                        <th>Branch Name</th>
                                        <th>Account Number</th>
                                        <th>Beneficiary Name</th>
                                        <th>IFSC Code</th>
                                        <th>MICR Code</th>
                                        <th>Swift Code</th>
                                        <th>Account Type Code</th>
                                        <th className='txt-center' style={{ width: 80 }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bankList.map((item) => (
                                        <tr
                                            key={`banks${item?.bank_account_id}`}
                                            className={item?.bank_account_id === values.bankId ? 'active' : ''}
                                        >
                                            <td className='rdotd'>
                                                <input
                                                    type="radio"
                                                    name="banks"
                                                    value={item?.bank_account_id}
                                                    checked={item?.bank_account_id == values.bankId}
                                                    onChange={() =>
                                                        setFieldValue('bankId', item?.bank_account_id)
                                                    }
                                                />
                                            </td>
                                            <td>{item?.bank_name}</td>
                                            <td>{item?.bank_branch_name}</td>
                                            <td>{item?.account_number}</td>
                                            <td>{item?.beneficiary_name}</td>
                                            <td>{item?.bank_ifsc_code}</td>
                                            <td>{item?.bank_micr_code}</td>
                                            <td>{item?.bank_swift_code}</td>
                                            <td>{item?.account_type_code}</td>
                                            <td>
                                                <div className="d-flex justify-content-center gap-2">
                                                    <button className='btn-action edit' onClick={() => { setAddBank(true); setEditBank(item); }}>
                                                        <FaEdit />
                                                    </button>
                                                    <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('bank'); setDeleteBank(item); }}>
                                                        <FaTrashAlt />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className='modalfooters'>
                    <div className='button-boxs grid'>
                        <button type='button' onClick={() => postSaveReference()} className='btn btn-primary'>Update</button>
                        <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                    </div>
                </div>
            </Modals>

            <Modals
                show={contactModal}
                handleClose={() => setContactModal(false)}
                title={`${values.orgName} Contact Info`}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >

                <div className='fieldsets'>
                    <div className='fieldsetsboxs'>
                        <h6>Contact Person</h6>
                        <div onClick={() => setAddContactPerson(!addContactPerson)} className='btnlinks'>+ Add New</div>
                    </div>
                    <div className='banksbox'>
                        {addContactPerson &&
                            <ContactPerson
                                orgId={ids}
                                toast={toast}
                                postUpdateOrganizationProfiles={postUpdateOrgProfiles}
                                setAddContactPerson={setAddContactPerson}
                                setEditContact={setEditContact}
                                editContact={editContact}
                                functionList={commonMaster?.function}
                                orgTypeCode='AP'
                            />
                        }
                        <div className="table-responsive">
                            <table className="table table-bordered text-nowrap mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ width: 60 }}></th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email Id</th>
                                        <th>Mobile Number</th>
                                        <th>Function</th>
                                        <th>Designation</th>
                                        <th>has User Profile</th>
                                        <th className='txt-center' style={{ width: 80 }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {contactPersonList?.map((item) => (
                                        <tr
                                            key={`contactPerson${item?.contact_person_id}`}
                                            className={item?.contact_person_id === values.contactId ? 'active' : ''}
                                        >
                                            <td className='rdotd'>
                                                <input
                                                    type="radio"
                                                    name="contactPerson"
                                                    value={item?.contact_person_id}
                                                    checked={item?.contact_person_id == values.contactId}
                                                    onChange={() =>
                                                        setFieldValue('contactId', item?.contact_person_id)
                                                    }
                                                />
                                            </td>
                                            <td>{item?.first_name}</td>
                                            <td>{item?.last_name}</td>
                                            <td>{item?.email}</td>
                                            <td>{item?.mobile_number}</td>
                                            <td>{item?.function?.name}</td>
                                            <td>{item?.designation?.name}</td>
                                            <td>
                                                <div className="switchs">
                                                    <input
                                                        type="checkbox"
                                                        checked={item?.is_user_profile ? true : false}
                                                        onChange={() =>
                                                            handleSwitchToggle(item?.contact_person_id)
                                                        }
                                                    />
                                                    <span className="slider round"></span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex justify-content-center gap-2">
                                                    <button className='btn-action edit' onClick={() => { setAddContactPerson(true); setEditContact(item); }}>
                                                        <FaEdit />
                                                    </button>
                                                    <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('contact'); setDeleteContact(item); }}>
                                                        <FaTrashAlt />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='modalfooters'>
                    <div className='button-boxs grid'>
                        <button type='button' onClick={() => postSaveReference()} className='btn btn-primary'>Update</button>
                        <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                    </div>
                </div>
            </Modals>

            <Modals
                show={showLogModal}
                handleClose={() => setShowLogModal(false)}
                title="Communication Log"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className='d-flex align-items-center'>
                                <label className='mb-0 mr-2'>Communication Types :</label>
                                <Tab.Container id="left-tabs-example" defaultActiveKey="AllProducts">
                                    <Nav variant="pills">
                                        <Nav.Item>
                                            <Nav.Link eventKey="phone" className="text-dark">
                                                <i className="fa fa-phone"></i>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="whatsapp" className="text-dark">
                                                <i className="fa fa-whatsapp"></i>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="instagram" className="text-dark">
                                                <i className="fa fa-instagram"></i>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="linkedin" className="text-dark">
                                                <i className="fa fa-linkedin"></i>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="group" className="text-dark">
                                                <i className="fa fa-group"></i>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Tab.Container>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Date</label>
                                <input
                                    type='date'
                                    id="date"
                                    name="date"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.date}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.date && touched.date && (
                                    <p className="errormsg">{errors.date}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Time</label>
                                <input
                                    type='time'
                                    id="time"
                                    name="time"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.time}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.time && touched.time && (
                                    <p className="errormsg">{errors.time}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Status</label>
                                <SelectFild
                                    Firstop='Select Status'
                                    selectName="status"
                                    options={[
                                        { name: 'Contact Later', id: 'Contact Later' },
                                        { name: 'Follow-up Required', id: 'Follow-up Required' },
                                        { name: 'Details Shared on Email', id: 'Details Shared on Email' },
                                        { name: 'Call Back Scheduled', id: 'Call Back Scheduled' },
                                        { name: 'Meeting Scheduled', id: 'Meeting Scheduled' },
                                        { name: 'Demo Completed', id: 'Demo Completed' },
                                        { name: 'Handed Over to BD', id: 'Handed Over to BD' },
                                        { name: 'Interested', id: 'Interested' },
                                        { name: 'Not Interested', id: 'Not Interested' },
                                        { name: 'Deal Closed', id: 'Deal Closed' },
                                    ]}
                                    value={values.status}
                                    onChange={(selectedOption) => setFieldValue("status", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.status && touched.status && (
                                    <p className="errormsg">{errors.status}</p>
                                )}
                            </div>

                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Next Scheduled Date</label>
                                <input
                                    type='date'
                                    id="scheduledDate"
                                    name="scheduledDate"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.scheduledDate}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.scheduledDate && touched.scheduledDate && (
                                    <p className="errormsg">{errors.scheduledDate}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Stage</label>
                                <SelectFild
                                    Firstop='Select Stage'
                                    selectName="stage"
                                    options={[
                                        { name: 'Hot', id: 'Hot' },
                                        { name: 'Warm', id: 'Warm' },
                                        { name: 'Cold', id: 'Cold' },
                                    ]}
                                    value={values.stage}
                                    onChange={(selectedOption) => setFieldValue("stage", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.stage && touched.stage && (
                                    <p className="errormsg">{errors.stage}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Notes</label>
                                <textarea
                                    id="Notes"
                                    name="Notes"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.Notes}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.Notes && touched.Notes && (
                                    <p className="errormsg">{errors.Notes}</p>
                                )}
                            </div>
                        </Col>
                    </Row>

                    <div className="table-responsive mt-5">
                        <table className="table txt-left table-bordered text-nowrap mb-0">
                            <thead>
                                <tr>
                                    <th>Follow-up Data</th>
                                    <th>Status</th>
                                    <th>Stage</th>
                                    <th>Remarks</th>
                                    <th>Next Scheduled Date</th>
                                    <th>Follow-up By</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>08/01/2026 </td>
                                    <td>Contact Later</td>
                                    <td>Cold</td>
                                    <td>Lorem Ipsum is simply dummy text of the printing and typesetting industry</td>
                                    <td>23/01/2026</td>
                                    <td>Tatvesh</td>
                                </tr>
                                <tr>
                                    <td>23/01/2026 </td>
                                    <td>Call Back Scheduled</td>
                                    <td>Warm</td>
                                    <td>Lorem Ipsum is simply dummy text of the printing and typesetting industry</td>
                                    <td>25/01/2026</td>
                                    <td>Tatvesh</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {shows ? (<>
                <Alert variant="danger" onClose={() => setShows(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete {fildsName == 'address' && 'This Address'}{fildsName == 'gst' && 'This GST'}
                        {fildsName == 'bank' && 'This Bank Information'}{fildsName == 'contact' && 'This Contact Person'} ?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeletes()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShows(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete Associate Partner ?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default AssociatePartner